
import React, { useState } from 'react';
import { Container, Row, Col, Alert, Spinner , Button } from 'react-bootstrap';
import { FaBan, FaTimes, FaSave } from 'react-icons/fa';
import Layout from '../Dashbaord/Layout.js/Layout';
import { useBillData } from './Editbill/hooks/useBillData';
import BillHeader from './Editbill/BillHeader';
import CustomerInfoCard from './Editbill/CustomerInfoCard';
import MenuCard from './Editbill/MenuCard';
import BillCalculationCard from './Editbill/BillCalculationCard';
import PaymentSummaryCard from './Editbill/PaymentSummaryCard';
import AddMenuItemModal from './Editbill/AddMenuItemModal';
import CancelEditModal from './Editbill/CancelEditModal';

const EditBill = () => {
  const {
    id,
    navigate,
    loading,
    saving,
    error,
    success,
    billData,
    originalValues,
    formData,
    setError,
    setSuccess,
    handleInputChange,
    addMenuItem,
    removeMenuItem,
    updateMenuItem,
    validateForm,
    handleSubmit,
    formatCurrency,
    calculateFoodBillBreakdown
  } = useBillData();

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showMenuModal, setShowMenuModal] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      await handleSubmit();
    }
  };

  const foodBillBreakdown = calculateFoodBillBreakdown();

  if (loading) {
    return (
      <Layout>
        <Container className="py-5 text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Loading bill data...</p>
        </Container>
      </Layout>
    );
  }

  if (!billData) {
    return (
      <Layout>
        <Container className="py-5 text-center">
          <FaBan className="text-muted mb-3" size={48} />
          <h3 className="text-muted">Bill not found</h3>
          <p className="text-muted mb-4">The bill you're looking for doesn't exist.</p>
          <Button variant="primary" onClick={() => navigate('/admin/dashboard/bills-list')}>
            Back to Bills
          </Button>
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container fluid className="py-4">
        <BillHeader
          refNo={billData.refNo}
          saving={saving}
          onCancel={() => setShowCancelModal(true)}
          onSubmit={onSubmit}
        />

        {error && (
          <Alert variant="danger" dismissible onClose={() => setError('')} className="border-0 shadow-sm mb-4">
            <FaTimes className="me-2" />
            {error}
          </Alert>
        )}
        
        {success && (
          <Alert variant="success" dismissible onClose={() => setSuccess('')} className="border-0 shadow-sm mb-4">
            <FaSave className="me-2" />
            {success}
          </Alert>
        )}

        <form onSubmit={onSubmit}>
          <Row>
            <Col lg={6}>
              <CustomerInfoCard
                formData={formData}
                originalValues={originalValues}
                formatCurrency={formatCurrency}
                onInputChange={handleInputChange}
              />
              
              <MenuCard
                menu={formData.menu}
                foodBillBreakdown={foodBillBreakdown}
                formatCurrency={formatCurrency}
                onAddClick={() => setShowMenuModal(true)}
                onRemoveItem={removeMenuItem}
                onUpdateItem={updateMenuItem}
              />
            </Col>
            
            <Col lg={6}>
              <BillCalculationCard
                formData={formData}
                originalValues={originalValues}
                formatCurrency={formatCurrency}
                onInputChange={handleInputChange}
              />
              
              <PaymentSummaryCard
                formData={formData}
                originalValues={originalValues}
                foodBillBreakdown={foodBillBreakdown}
                formatCurrency={formatCurrency}
              />
            </Col>
          </Row>
        </form>
      </Container>

      <AddMenuItemModal
        show={showMenuModal}
        onHide={() => setShowMenuModal(false)}
        onAdd={addMenuItem}
      />

      <CancelEditModal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        onConfirm={() => {
          setShowCancelModal(false);
          navigate('/admin/dashboard/bills-list');
        }}
      />
    </Layout>
  );
};

export default EditBill;